<template>
  <el-form
    ref="form"
    :model="form">
    <el-row>
      <el-col :span="6">
        <el-form-item
          class="base-form"
          label="默认竞价"
          prop="bid">
        <gj-input
            v-model="defaultBid"
            v-number.price
            maxlength="12"
            width="200px">
          <template #prepend>{{ currencySymbol }}</template>
        </gj-input>
      </el-form-item>
      </el-col>
    </el-row>
    <el-row
        type="flex"
        class="gj-picker">
      <div class="gj-picker__editor" :style="{width}">
        <el-tabs :value="'first'">
          <el-tab-pane name="first" class="tabs__content0">
            <template #label>
              <div class="dfc">
                <span class="msg">分类</span>
                <gj-help>各类商品是按相似性划分在一起的商品，如女士跑鞋。</gj-help>
              </div>
            </template>
            <gj-table
              :index="false"
              :show-pagination="false"
              :show-overflow="false"
              :adapt-height="false"
              :loading="loading"
              :height="413"
              :data="suggestedClassificationData"
              :columns="columns0"
              class="suggest-table">
            <template v-slot:header:op>
              <gj-button
                  type="text"
                  @click="addAllCategory()"
              >全部定位</gj-button>
            </template>
            <template v-slot:recommendCategory="{ row }">
              <div style="line-height: 18px;">
                <div>{{row.categoryPath | defaultShow}}</div>
                <div><span style="font-weight: bold;">分类：</span>{{row.categoryName | defaultShow}}</div>
              </div>
            </template>
            <template v-slot:op="{ index, row }">
              <gj-button
                  type="primary"
                  :disabled="row.isAddPage || row.isAdd"
                  style="padding: 5px 15px;"
                  @click="addCategory(index, row)"
              >定位</gj-button>
              <gj-button
                  type="text"
                  @click="refineCategory(index, row)"
              >细化</gj-button>
            </template>
          </gj-table>
          </el-tab-pane>
          <el-tab-pane name="second">
            <template #label>
              <div class="dfc">
                <span class="msg">商品 </span>
                <gj-help>定位到与您广告中宣传的商品类似的各个商品。</gj-help>
              </div>
            </template>
            <el-tabs :value="'first'" class="tabs-son">
              <el-tab-pane name="first">
                <template #label>
                  建议ASIN <gj-help>根据您广告中宣传的商品建议的商品。</gj-help>
                </template>
                <gj-table
                    :index="false"
                    :show-pagination="false"
                    :show-overflow="false"
                    :adapt-height="false"
                    :loading="loading"
                    :height="379"
                    :data="recommendedASINData"
                    :columns="recommendAsinColumns">
                  <template v-slot:asin="{ row }">
                    <span style="color: #666666;">ASIN：{{ row.asin }}</span>
                  </template>
                  <template v-slot:header:op>
                    <gj-button
                        type="text"
                        @click="addAllRecommendAsin()"
                    >全部添加</gj-button>
                  </template>
                  <template v-slot:op="{ index, row }">
                    <div style="text-align: right;">
                      <gj-button type="text" :disabled="row.isAddPage" @click="addRecommendAsin(index, row)">添加</gj-button>
                    </div>
                  </template>
                </gj-table>
              </el-tab-pane>
              <el-tab-pane
                  label="输入ASIN"
                  name="second">
                <div style="margin-top: 15px;padding: 0 12px">
                  <div style="margin-bottom: 10px;">
                    <gj-textarea
                        v-model="inputText"
                        :styles="{ 'border-color': this.errorKeyword ? '#F56C6C' : '', ...textareaStyles }"
                        placeholder="请输入ASIN，一行一个，回车换行">
                    </gj-textarea>
                  </div>
                  <el-row
                      type="flex"
                      align="middle"
                      justify="space-between"
                      class="gj-picker__editor--footer">
                    <span :class="{red: errorKeyword}">ASIN不得包含特殊字符，如@、#、*和$等</span>
                    <gj-button
                        type="primary"
                        @click="addByInput"
                        :disabled="!isMeaningful(inputText)"
                        :loading="loadingInput"
                    >添加</gj-button>
                  </el-row>
                  <el-row style="margin-top: 10px;">
                    <gj-alert
                      v-if="alert.error && alert.error.length !== 0"
                      ref="gjAlert"
                      type="error"
                      show-icon
                      closable
                      @close="closeError">
                      <template #title>
                        <div>{{ `成功${alert.success.length || 0}个，失败${alert.error.length || 0}个` }}</div>
                        <div class="alert-error">{{ `失败原因：ASIN格式不正确或ASIN重复添加，失败的ASIN：${alert.error.join("，")}`}}</div>
                      </template>
                    </gj-alert>
                    <gj-alert
                      v-else
                      ref="gjAlert"
                      type="success"
                      show-icon
                      closable
                      @close="closeError">
                      <template #title>
                        <div class="alert-content">
                          {{ `${alert.success.length || 0}个ASIN全部添加成功` }}
                        </div>
                      </template>
                    </gj-alert>
                  </el-row>
                </div>
              </el-tab-pane>
            </el-tabs>
          </el-tab-pane>
        </el-tabs>
      </div>
      <div class="gj-picker__table" :style="{width}">
        <div class="gj-picker__table--title">
          已添加 {{form.items.length}} 个{{title}}<span class="gj-picker__table--tip">（最多可添加1000个，会过滤重复的{{title}}）</span>
        </div>
        <gj-table
            :index="false"
            :show-pagination="false"
            :show-overflow="false"
            :adapt-height="false"
            :height="410"
            :data="form.items"
            :columns="columns">
          <template v-slot:header:op>
            <gj-button
                type="text"
                @click="deleteAllItem()"
            >全部移除</gj-button>
          </template>
          <template v-slot:recommendedBid="{ row }">
            <gj-button type="text" @click="applicationFn('item', row)">{{ row.recommendedBid  | defaultShow(currencySymbol) }}</gj-button>
          </template>
          <template v-slot:header:application>
            <gj-button type="text" @click="applicationFn('all')">全部应用</gj-button>
          </template>
          <template v-slot:application="{ row }">
            {{ row.rangeStart ? currencySymbol +  row.rangeStart : ""}}
               -
            {{ row.rangeEnd ? currencySymbol +  row.rangeEnd : ""}}
          </template>
          <template v-slot:category="{ row }">
            <div v-if="!row.asin" style="line-height: 18px;">
              <gj-tooltip
                :text-line="1"
                :content="row.categoryPath">
                {{row.categoryPath | defaultShow}}
              </gj-tooltip>
              <!-- <div>{{row.categoryPath | defaultShow}}</div> -->
              <div v-gutter="8">
                <gj-tooltip
                  :text-line="1"
                  :content="row.categoryName">
                  <strong>分类：</strong>{{row.categoryName | defaultShow}}
                </gj-tooltip>
              </div>
              <div v-gutter="8">
                <strong v-if="row.brandId">品牌：</strong>{{row.brandName}}
              </div>
              <div v-gutter="8">
                <span v-if="isMeaningful(row.lowPrice) && isMeaningful(row.maxPrice) "><strong>商品价格：</strong>{{row.lowPrice | defaultShow}} - {{row.maxPrice | defaultShow}} </span>
                <span v-if="isMeaningful(row.lowPrice) && !isMeaningful(row.maxPrice) "><strong>商品价格：</strong>不低于{{row.lowPrice | defaultShow}} </span>
                <span v-if="!isMeaningful(row.lowPrice) && isMeaningful(row.maxPrice) "><strong>商品价格：</strong>不低于{{row.maxPrice | defaultShow}} </span>
                <span v-if="isMeaningful(row.marks)"><strong>评分：</strong>{{starTo(row.marks)}} 星</span>
                <!-- <span v-if="isMeaningful(row.prime) && row.prime !== 'NO'"><strong>配送：</strong>{{primeTo(row.prime)}} </span> -->
              </div>
            </div>
            <template v-if="row.asin">
              <div><strong>商品：</strong>{{row.asin | defaultShow}}</div>
            </template>
          </template>
          <template v-slot:bid="{ index }">
            <el-form-item
                :prop="`items.${index}.bid`"
                :rules="[
                  { required: true, message: '请输入竞价', trigger: ['blur', 'change'] },
                  $gjReRule(RE.num(2), '请输入两位小数正数'),
                  $gjMinRule(0.02, '应大于等于0.02'),
                ]"
                class="gj-table-item">
              <gj-input
                  width="120px"
                  v-model="form.items[index].bid"
                  :clearable="false"
                  size="mini">
                <template #prepend>{{currencySymbol}}</template>
              </gj-input>
            </el-form-item>
          </template>
          <template v-slot:op="{ index, row }">
            <gj-button
                type="text"
                @click="deleteItem(index, row)"
            >移除</gj-button>
          </template>
        </gj-table>
      </div>
    </el-row>
    <div class="gj-picker-solid"></div>
  </el-form>
</template>

<script>
import {AdDefaultBid} from "@/views/modules/ad/common/enum";
  import { formMixin, formRuleMixin, isMeaningfulMixin } from "@/minxins";
  import { isMeaningful, unique } from "@/utils/common";
  import { getSuggestedBrand, getSpAdProductTargetProduct, getSuggestedClassification, getRecommendedASIN} from "@/api/ad";
  import AppProductTargetRefineModal from "./modal/product-target-refine-modal";
import {mapGetters} from "vuex";

  export default {
    name: "app-product-target-picker",
    mixins: [isMeaningfulMixin, formMixin, formRuleMixin],
    props: {
      title: {
        required: true,
      },
      currencySymbol: {
        required: true,
        default: null
      },
      marketId: {
        required: true,
        default: null
      },
      width: {
        type: String,
        default: '500px',
      },
      params: {
        default: () => ({}),
      },
      bid:null
    },
    created() {
      this.defaultBid = AdDefaultBid[this.markets.find(r => r.id === this.marketId).countryCode]?.SDDefaultBid || null;
    },
    mounted () {
      this.$refs.gjAlert.$refs.alert.visible = false;
    },
    data() {
      return {
        defaultBid: "1.00", // 默认竞价
        loading: false,
        loadingInput: false,
        searchText: "",
        recommendCategoryData: [],
        recommendAsinData: [],
        suggestedClassificationData: [],
        recommendedASINData: [],
        keyword: null,
        inputText: null,
        columns0: [
          {id: 'recommendCategory', header: '建议/分类',field: 'slot:recommendCategory', minWidth: '180px'},
          {id: 'op', header: 'slot:op',field: 'slot:op', width: '120px'},
        ],
        columns: [
          {id: 'category', header: '分类和商品',field: 'slot:category', minWidth: '150px'},
          {id: 'recommendedBid', header: '建议竞价', field: 'slot:recommendedBid', minWidth: '70px', align: 'right'},
          {id: 'application', header: 'slot:application', field: 'slot:application', minWidth: '120px'},
          {id: 'bid', header: '竞价', field: 'slot:bid', minWidth: '110px'},
          {id: 'op', header: 'slot:op',field: 'slot:op', minWidth: '80px'},
        ],
        recommendAsinColumns: [
          {id: 'asin', header: 'ASIN', field: 'slot:asin', minWidth: '130px'},
          {id: 'op', header: 'slot:op',field: 'slot:op', width: '80px'},
        ],
        errorKeyword: false,
        keywordStyle: {height: '292px'},
        suggestCategoriesLoading: false,
        suggestProductLoading: false,
        textareaStyles: {
          height: '298px',
          fontSize: '12px',
          resize:"none"
        },
        alert: { // 错误提示
          success: [],
          error: [],
        }
      }
    },
    watch: {
      inputText(val) {
        this.errorKeyword = !/^[^!#%<>@*$]*$/.test(val);
      },
      bid:{
        handler(val){
          this.defaultBid = val
        },
        immediate: true
      }
    },
    computed:{
      ...mapGetters({
        markets: 'authMarkets'
      }),
    },
    methods: {
      async getSuggestedClassification(param) {
        this.loading = true
        let params = {
          campaignId: null, 
          marketId: this.marketId,
        }
        Object.assign(params, param)
        try {
          let { data } = await getSuggestedClassification(params)
          this.suggestedClassificationData = data || []
        } finally {
          this.loading = false
        }
      },
      async getRecommendedASIN(param) {
        this.loading = true
        let params = {
          campaignId: null,
          marketId: this.marketId,
          nextToken: null,
          maxResults: 100,
        }
        Object.assign(params, param)
        try {
          let { data } = await getRecommendedASIN(params)
          this.recommendedASINData = data?.asinAndBidVOS || []
        } finally {
          this.loading = false
        }
      },
      // 应用
      applicationFn(type, row) {
        const opt = {
          all:()=> {
            this.form.items.forEach(item => {
              item.bid = item.recommendedBid
            })
          },
          item: () => {
            row.bid = row.recommendedBid
          },
        }
        opt[type]()
      },
      getSuggestProduct(asinList) {
        this.suggestProductLoading = true;
        getSpAdProductTargetProduct({
          marketId: this.marketId,
          asinList,
        })
          .then(({recommendedProducts}) => {
            this.recommendAsinData = recommendedProducts.map(e => ({
              ...e,
              asin: e.recommendedTargetAsin
            }));
            this.refreshBtnDisable();
          })
          .complete(() => this.suggestProductLoading = false);
      },
      addAllRecommendAsin() {
        this.addAllItem(this.recommendedASINData, 'asin', 'asin');
      },
      addRecommendAsin(index, row) {
        this.addAllItem([row], 'asin', 'asin');
      },
      addAllCategory() {
        this.addAllItem(this.suggestedClassificationData, 'categoryPath', 'categoryPath');
      },
      addCategory(index, row) {
        // console.log('zs', row);
        this.addAllItem([row], 'categoryPath', 'categoryPath');
      },
      refineCategory(index, row) {
        const modal = this.$gjCreate(AppProductTargetRefineModal, {
          props: {
            brandOption$: getSuggestedBrand({
              marketId: this.marketId,
              categoryId: row.categoryId
            }),
            category: row.categoryName,
            item: row,
            currencySymbol: this.currencySymbol
          },
          on: {
            refine: () => {
              const item = {...row};
              Object.assign(item, modal.form);
              this.addAllItem([item], 'refine', 'categoryPath');
            }
          }
        });
      },
      refreshBtnDisable() {
        this._refreshBtnDisable(this.suggestedClassificationData, 'categoryPath', 'categoryPath');
        this._refreshBtnDisable(this.recommendedASINData, 'asin', 'asin');
      },
      _refreshBtnDisable(items, type, key) {
        items.forEach(e1 => {
          if (this.form.items.some(e2 => `${type}_${e1[key]}` === e2.identity)) {
            this.$set(e1, 'isAddPage', true);
          } else {
            this.$set(e1, 'isAddPage', false);
          }
        });
      },
      addAllItem(items, type, key) {
        this.form.items = unique([].concat(this.form.items).concat(
          items.map(e => ({
            identity: `${type}_${e[key]}`,
            ...e,
            bid: this.defaultBid,
            type,
          }))
        ), 'identity');
        this.refreshBtnDisable();
      },
      deleteAllItem() {
        this.form.items = [];
        this.refreshBtnDisable();
      },
      deleteItem(index) {
        this.form.items.splice(index, 1);
        this.refreshBtnDisable();
      },
      async addByInput() {
        this.loadingInput = true;
        this.alert.success = [];
        this.alert.error = [];
        const asinList = this.inputText.split('\n').map(item => item.replace(/^(\s|\n)+|(\s|\n)+?$/, '')); // 所有
        const items = this.form.items.map(e => e.asin);
        // 校验
        asinList.forEach(element => {
          let str = element.toUpperCase()
          let rule = /^[B|b]0[A-Za-z0-9]{8}$/.test(str);
          if (rule && !this.alert.success.includes(str) && !items.includes(str)) {
            this.alert.success.push(str);
          }else {
            this.alert.error.push(element);
          }
        });
        // 设置提示
        this.textareaStyles.height = '198px';
        this.$refs.gjAlert.$refs.alert.visible = true;
        this.addAllItem(this.alert.success.map(e => ({asin: e})),'asin', 'asin');
        this.inputText = null;
        this.loadingInput = false;
        let asins = this.alert.success
        // let asins = this.inputText.split('\n')
        //     .map(item => item.replace(/^(\s|\n)+|(\s|\n)+?$/, ''))
        //     .filter(item => isMeaningful(item) && !/\n+/.test(item))
        // this.loadingInput = true
        if(asins.length === 0) {
          this.inputText = null;
          this.loadingInput = false
          return false
        }
        let params = {
          asins,
          queryType: 1,
          marketId: this.marketId,
          adFormat: this.params.adFormat
        }
        try {
          let { data } = await getRecommendedASIN(params)
          let recommendedASINData = data.asinAndBidVOS || []
          this.addAllItem(recommendedASINData, 'asin', 'asin');
          // console.log('zs', recommendedASINData);
          this.inputText = null;
          this.loadingInput = false
        } finally {
          this.loadingInput = false
        }
      },
      // 关闭错误
      closeError() {
        setTimeout(() => {
          this.textareaStyles.height = '298px';
        }, 300);
      },
      starTo(marks) {
        if (isMeaningful(marks)) {
          return marks[0] + '-' + marks[1];
        } else {
          return '0-5';
        }
      },
      primeTo(prime) {
        if (prime === 'true') {
          return '具备Prime资格';
        } else {
          return '不具备Prime资格';
        }
      },
      formValidate() {
        let formValid = this.form.items.length > 0;
        if (!formValid) {
          this.$gjMessage.error('请添加商品投放');
          return false;
        }
        this.$refs.form.validate((valid) => {
          formValid = formValid && valid;
        });
        return formValid;
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "picker";
  .dfc {
    display: flex;
    align-items: center;
    justify-content: center;
    .msg {
      padding-right: 2px;
    }
  }
  .gj-picker__editor {
    padding: 0;
  }
  .gj-picker,
  .gj-picker__editor {
    height: 445px;
  }

  .gj-picker__editor {
    height: 443px !important;
    &::before {
      content: "商品投放";
      left: -63px;
    }
    &::after {
      content: "*";
      color: #F56C6C;
      position: absolute;
      font-size: 12px;
      top: 0;
      left: -73px;
    }
  }
  .default-bid {
    margin-bottom: 0;
    position: absolute;
    top: 0;
    left: 280px;
  }
  /deep/.tabs-son {
    .el-tabs__header {
      background: #fff;
      padding-top: 5px;
    }
    .el-tabs__active-bar {
      display: none;
    }
    &.second {
      .el-tabs__content {
        padding: 0;
      }
    }
  }
  /deep/ .el-tabs__header {
    margin-bottom: 0 !important;
  }

  /deep/ .gj-picker__editor--search-input .el-input__inner {
    height: 46px;
    line-height: 46px;
    font-size: 14px;
  }

  /deep/ .gj-table td {
    padding: 5px 0 !important;
  }
  /deep/.el-tree-node__content {
    height: 38px;
    padding-right: 15px;
  }
  .tabs__content0 {
    /deep/.el-tabs__content {
      padding: 0 !important;
    }
  }
  .custom-tree-node {
    padding: 15px 0;
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 12px;
  }
  .el-button--primary {
    &.el-button--mini {
      width: 48px;
      height: 22px;
      text-align: center;
      padding: 0 !important;
    }
  }
  .gj-picker__editor--search {
    .gj-picker__editor--header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 5px 50px 5px 8px;
      font-size: 12px;
      color: #1F6EEF;
      /deep/.el-input__inner {
        height: 28px;
        line-height: 28px;
      }
      .el-icon-search {
        cursor: pointer;
      }
    }
  }
  /deep/ .vxe-table--border-line{
    border: none;
  }
  .gj-picker__table--title {
    height: 29px !important;
    line-height: 29px !important;
    border-bottom: 1px solid #E4E7ED !important;
  }
  // /deep/ .el-tabs__nav-wrap{
  //   height: 32px;
  // }
  /deep/.vxe-table--body {
    .vxe-body--row {
      .vxe-body--column {
        height: 58px !important;
      }
    }
  }
</style>


